'use client';

import { Body, Heading } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import { BENEFITS } from '../../constants';

import styles from './styles.module.css';

import { ContentSegment } from '@/components/ContentSegment';

export function Benefits() {
  const t = useTranslations('topSellerProgram');

  return (
    <section className={styles.section}>
      <ContentSegment>
        <ContentSegment.Image>
          <div className={styles.stampContainer}>
            <img
              className={styles.stamp}
              src={`${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/topSellerProgram/depop-top-seller-icon.svg`}
              alt={t('Benefits.BadgeAlt')}
            />
          </div>
        </ContentSegment.Image>
        <ContentSegment.Content>
          <ContentSegment.Title variant="lg">
            {t('Benefits.Heading')}
          </ContentSegment.Title>
          <ul className={styles.benefitsList}>
            {BENEFITS.map(({ icon: Icon, titleKey, descriptionKey }) => (
              <li key={titleKey} className={styles.benefitItem}>
                <div className={styles.iconWrapper}>
                  <Icon size="md" />
                </div>
                <div className={styles.benefitText}>
                  <Heading variant="md" as="h3">
                    {t(titleKey)}
                  </Heading>
                  <Body variant="sm-regular">{t(descriptionKey)}</Body>
                </div>
              </li>
            ))}
          </ul>
        </ContentSegment.Content>
      </ContentSegment>
    </section>
  );
}
